export default __webpack_public_path__ + "static/media/dashboard_white.b652da7c.svg";